<template>
    <div>
        <!-- Filters -->
        <b-card no-body>
            <b-card-header class="pb-50">
                <h5>Filter Location</h5>
            </b-card-header>
            <b-card-body>
                <b-row>
                    <b-col cols="12" md="10" class="mb-md-0 mb-2">
                        <location-filters
                            size="sm"
                            align="horizontal"
                            @filter="changeFilter"
                        />
                    </b-col>
                    <b-col cols="12" md="2" class="pt-2">
                        <b-button
                            variant="outline-success"
                            class="btn-icon float-right"
                            size="sm"
                            title="Download Excel"
                            @click="download(true)"
                        >
                            <span>Download Excel</span>
                            <span class="ml-1"><feather-icon icon="DownloadIcon"/></span>
                            <!-- <img src="@/assets/images/icons/export_xls.png" width="24" height="24" /> -->
                        </b-button>
                    </b-col>
                </b-row>

                <b-row class="mt-1">
                    <b-col cols="12">
                        <b-table
                            striped
                            hover
                            small
                            ref="records"
                            class="position-relative"
                            :items="rows"
                            responsive
                            :fields="columns"
                            primary-key="id"
                            show-empty
                            empty-text="No records found"
                        >
                            <template #cell(value)="data">
                                <span class="text-nowrap">{{ data.value.toLocaleString() }}</span>
                            </template>
                        </b-table>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
        <!-- ./Filters -->
    </div>
</template>

<script>
import {
    BRow, BCol, BModal, VBModal, BButton, BTable,
    BBadge, BDropdown, BDropdownItem, BPagination, BSpinner, BMedia, BAvatar, BLink,
    BForm, BFormGroup, BFormSelect, BFormSelectOption, BFormInput,
    BFormCheckbox,
    BCard, BCardHeader, BCardSubTitle, BCardBody,
 } from 'bootstrap-vue'
import LocationFilters from '@core/components/cromis/filters/LocationFilters'
import store from '@/store'
import axios from '@axios'
import { ref, onUnmounted, onMounted } from '@vue/composition-api'
import vSelect from 'vue-select'
import loansStoreModule from '@/views/cromis/loans/loansStoreModule'

export default {
    props: {},
    components: {
        BCard,
        BCardHeader,
        BCardSubTitle,
        BCardBody,
        BRow,
        BCol,
        BForm,
        BFormGroup,
        BFormInput,
        BFormSelect,
        BFormSelectOption,
        BFormCheckbox,
        BModal,
        BButton,
        BSpinner,
        BMedia,
        BLink,
        BAvatar,
        BTable,
        BBadge,
        BDropdown,
        BDropdownItem,
        BPagination,

        vSelect,
        LocationFilters,
    },
    directives: {
        'b-modal': VBModal,
    },
    
    setup (props, context) {
        const user = ref(JSON.parse(localStorage.getItem('userData')))
        const serverData = ref([])

        const columns = ref([])
        const rows = ref([])
        const totalsRow = ref({})
        const location_id = ref(null)

        const CROMIS_LOAN_STORE_MODULE_NAME = 'cromis-loans'

        // Register module
        if (!store.hasModule(CROMIS_LOAN_STORE_MODULE_NAME)) store.registerModule(CROMIS_LOAN_STORE_MODULE_NAME, loansStoreModule)

        // UnRegister on leave
        onUnmounted(() => {
            if (store.hasModule(CROMIS_LOAN_STORE_MODULE_NAME)) store.unregisterModule(CROMIS_LOAN_STORE_MODULE_NAME)
        })

        const isAddNewUserSidebarActive = ref(false)

        onMounted(async () => {
            await getData()
        })

        const getData = async () => {
            await store.dispatch('cromis-loans/loanDashboard', { report_id: user.value.id, data_type: 0, location_id: location_id.value })
                        .then(response => {
                            if(serverData.value.length > 0){
                                serverData.value.splice(0)
                            }

                            serverData.value = response.data
                            repopulateData()
                        })
                        .catch(error => {
                            console.log('got error', error)
                        })
        }

        const repopulateData = () => {
            if(serverData.value.areas.length > 0){
                if(columns.value.length > 0){
                    columns.value.splice(0)
                }

                columns.value.push({ key: serverData.value.level.name.toLowerCase(), label: serverData.value.level.name.toUpperCase() })

                serverData.value.areas[0].inputs.forEach(input => {
                    columns.value.push({ key: input.name.toLowerCase().replace(/ /g,"_"), label: input.name.toUpperCase()})
                })

                columns.value.push({ key: 'value', label: 'Value' })

                if(rows.value.length > 0){
                    rows.value.splice(0)
                }

                totalsRow.value = {
                    id: 0,
                    [serverData.value.level.name.toLowerCase()]: 'TOTAL',
                }

                for(let i = 1; i < columns.value.length; i++){
                    totalsRow.value[columns.value[i].key] = 0
                }

                totalsRow.value['value'] = 0

                serverData.value.areas.forEach(area => {
                    let record = {}
                    let id = 'id'
                    record[id] = area.id
                    record[columns.value[0].key] = area.name.toUpperCase()
                    record['value'] = 0

                    let i = 0
                    area.inputs.forEach(input => {
                        i += 1

                        if(columns.value[i].key != 'value'){
                            record[columns.value[i].key] = input.value.toLocaleString()
                            totalsRow.value[columns.value[i].key] += input.value
                            record['value'] += input.value
                            totalsRow.value['value'] += input.value
                        }
                    })

                    rows.value.push(record)
                })

                // totalsRow['value'] = totalValue

                rows.value.push(totalsRow.value)

                // console.log('Columns:', columns.value, 'Rows:', rows.value)
            }
        }

        const changeFilter = async (location) => {
            location_id.value = location !== null? location.id : null
            await getData()
        }

        const download = async () => {
            window.open(`${ axios.defaults.baseURL }/reports/loan_dashboard?report_id=${ user.value.id }&data_type=2&location_id=${ location_id.value }`, '_blank')
        }

        return {
            changeFilter,
            columns,
            rows,
            download,
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-select.scss';
</style>
